var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M30.1 17.18c-9.71-.1-9.71-.1-10.1.29a1 1 0 0 0-.29.71c0 1.68-1.67 3-3.71 3s-3.71-1.35-3.71-3a1 1 0 0 0-.29-.71c-.35-.34-.39-.38-6.83-.32V6.23l9.14 7.87.09.07a2.81 2.81 0 0 0 3.2 0l.09-.07 9.14-7.88v7.69a1 1 0 0 0 2 0V6A2.84 2.84 0 0 0 26 3.18H6a2.77 2.77 0 0 0-1.62.52.81.81 0 0 0-.33.3H4a2.83 2.83 0 0 0-.85 2v11.16H1.88A1.92 1.92 0 0 0 0 19.09v7.81a1.92 1.92 0 0 0 1.92 1.92h28.16A1.92 1.92 0 0 0 32 26.9v-7.81a1.92 1.92 0 0 0-1.9-1.91zm-13.66-4.64a.82.82 0 0 1-.88 0L7 5.18h18l-8.56 7.36zM30 26.82H2v-7.65h8.4a5.57 5.57 0 0 0 5.6 4.04 5.57 5.57 0 0 0 5.6-4.07H30v7.68z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.3b7a602eadd7ed40f1fc4e891787950d.svg";
export { ForwardRef as ReactComponent };